import { useNavigate } from 'react-router-dom';
import { useServicePageDefacementSites } from '@/api/waap';
import { AdvancedSiteList } from '@/pages/services/waap/aiwaf/advanced-protection/AdvancedSiteList';

/**
 * Page Defacement Mitigation — the website list shown under the Advanced
 * Protection tab. Per-website: each row's status reflects whether config.tamper
 * is enabled; Edit opens the per-site rule form.
 */
export function PageDefacementPanel({ serviceId, base }: { serviceId: string; base: string }) {
  const navigate = useNavigate();
  const { data: sites = [], isLoading } = useServicePageDefacementSites(serviceId);

  return (
    <AdvancedSiteList
      title="Websites"
      description="Page defacement mitigation ensures that website visitors always get intact web pages, even if websites are hacked or tampered with."
      sites={sites}
      isLoading={isLoading}
      onEdit={(siteId) => navigate(`${base}/aiwaf/advanced/page-defacement/${siteId}`)}
    />
  );
}
